import { useContext } from 'react'
import { isToday } from 'date-fns'

import { DateTimePickerContext } from 'components/form/DateTimePicker/helpers'
import theme from 'styles/theme'

import { DayStyleProps } from './styles'

export const getTextColor = ({ isSelected, isDisabled }: DayStyleProps): string => {
  if (isSelected) {
    return theme.token.var('colors.white')
  }

  if (isDisabled) {
    return theme.token.var('colors.gray.300')
  }

  return 'initial'
}

export const getBackground = ({ isSelected }: DayStyleProps): string => {
  if (isSelected) {
    return theme.token.var('colors.green.a200')
  }

  return theme.token.var('colors.initial')
}

export const getBorderColor = ({ isToday, isSelected }: DayStyleProps): string => {
  if (isToday && !isSelected) {
    return theme.token.var('colors.green.a150')
  }

  return 'transparent'
}

export const getFontWeight = ({ isSelected }: DayStyleProps) => {
  if (isSelected) {
    return 'bold'
  }

  return 'normal'
}

export const useAllDayHelpers = (index: number) => {
  const { dateTimeState } = useContext(DateTimePickerContext)
  const {
    value,
    datePicker,
    props: { shouldDisableDate },
  } = dateTimeState

  const currentDay: Date = new Date(datePicker.year, datePicker.month, index + 1)
  const isTodayBoolean: boolean = isToday(currentDay)
  const isSelected: boolean =
    value.day === index + 1 && value.month === datePicker.month && value.year === datePicker.year
  const isDisabled: boolean = shouldDisableDate ? shouldDisableDate(currentDay) : false

  return {
    currentDay,
    isToday: isTodayBoolean,
    isSelected,
    isDisabled,
  }
}
